import { connectSearchBox } from 'react-instantsearch-dom'

const VirtualSearchBox = connectSearchBox(() => null)

export default VirtualSearchBox
